export type ModuleCategory = 'community' | 'communications' | 'finance' | 'system';

export interface ModuleTile {
  readonly to: string;
  readonly labelKey: string;
  /** Same permission keys `app-shell.tsx`'s `NAV_ITEMS` uses — kept as a
   *  separate list rather than shared with it, since the two serve different
   *  shapes: the shell nav is every navigable page (including sub-views like
   *  journal entries), this is one tile per top-level module. */
  readonly permission: string;
  readonly category: ModuleCategory;
}

export const MODULE_TILES: readonly ModuleTile[] = [
  {
    to: '/people',
    labelKey: 'navigation.people',
    permission: 'people.person.read',
    category: 'community',
  },
  {
    to: '/groups',
    labelKey: 'groups.group.title',
    permission: 'groups.group.read',
    category: 'community',
  },
  {
    to: '/events',
    labelKey: 'navigation.events',
    permission: 'events.event.read',
    category: 'community',
  },
  {
    to: '/attendance',
    labelKey: 'navigation.attendance',
    permission: 'attendance.record.read',
    category: 'community',
  },
  {
    to: '/kids',
    labelKey: 'kids.checkin.title',
    permission: 'kids.checkin.read',
    category: 'community',
  },
  {
    to: '/forms',
    labelKey: 'navigation.forms',
    permission: 'forms.form.read',
    category: 'community',
  },

  {
    to: '/communications',
    labelKey: 'communications.campaign.title',
    permission: 'communications.campaign.read',
    category: 'communications',
  },
  {
    to: '/notifications',
    labelKey: 'notifications.log.title',
    permission: 'notification.log.read',
    category: 'communications',
  },

  {
    to: '/giving',
    labelKey: 'giving.donation.title',
    permission: 'giving.donation.read',
    category: 'finance',
  },
  {
    to: '/finance',
    labelKey: 'finance.account.title',
    permission: 'finance.account.read',
    category: 'finance',
  },
  {
    to: '/billing',
    labelKey: 'billing.subscription.title',
    permission: 'billing.subscription.read',
    category: 'finance',
  },

  {
    to: '/cloud',
    labelKey: 'navigation.myCloud',
    permission: 'file.object.read',
    category: 'system',
  },
  {
    to: '/inventory',
    labelKey: 'inventory.item.title',
    permission: 'inventory.item.read',
    category: 'system',
  },
  {
    to: '/academic/schools',
    labelKey: 'academic.school.title',
    permission: 'academic.school.read',
    category: 'system',
  },
  {
    to: '/administration',
    labelKey: 'navigation.administration',
    permission: 'tenancy.tenant.admin',
    category: 'system',
  },
];

export const MODULE_CATEGORY_LABEL_KEYS: Record<ModuleCategory, string> = {
  community: 'navigation.community',
  communications: 'navigation.communications',
  finance: 'navigation.givingAndFinance',
  system: 'navigation.system',
};
